import { TransformDate } from '../../../shared/decorators/transform-date.decorator';
import { TransformFloat } from '../../../shared/decorators/transform-float.decorator';
import { ApiRequestFilters } from '../../../shared/types/api-request-filters';
import { AssetReservationStatusEnum } from '../enums/asset-reservation-status.enum';

/**
 * Asset reservations filters
 */
export class AssetReservationsFilters extends ApiRequestFilters {
	/**
	 * Accounts id values
	 */
	accounts?: number[];

	/**
	 * Agents id values
	 */
	agents?: number[];

	/**
	 * Assets id values
	 */
	assets?: number[];

	/**
	 * Gross amount from
	 */
	@TransformFloat()
	totalGrossFrom?: number;

	/**
	 * Gross amount from
	 */
	@TransformFloat()
	totalGrossTo?: number;

	/**
	 * Check-out from date
	 */
	@TransformDate()
	startsAtFrom?: Date;

	/**
	 * Check-out to date
	 */
	@TransformDate()
	startsAtTo?: Date;

	/**
	 * Check-in from date
	 */
	@TransformDate()
	endsAtFrom?: Date;

	/**
	 * Check-in to date
	 */
	@TransformDate()
	endsAtTo?: Date;

	/**
	 * Individual dates that are contained within the StartsAt and EndsAt period
	 */
	@TransformDate()
	containsDates?: Date[];

	/**
	 * Status values
	 */
	statuses?: AssetReservationStatusEnum[];
}
